import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
  DropdownMenuSubTrigger,
  DropdownMenuPortal,
  DropdownMenuSub,
  DropdownMenuSubContent,
} from "@/components/ui/dropdown-menu";
import {
  CodeIcon,
  CogIcon,
  FlipHorizontalIcon,
  FlipVerticalIcon,
  ImageIcon,
  ImagesIcon,
  PaperclipIcon,
  SplitIcon,
} from "lucide-react";
import { Button } from "@/components/ui/button";
import { useTranslation } from "react-i18next";
import { useIsMobile } from "@/hooks/useIsMobile";

interface Props {
  onClickAttachContent: () => void;
  onClickAttachContentGroup: () => void;
  onClickAttachHtml: () => void;
  onClickAttachUrl: () => void;
  onClickAttachDynamicTemplate: () => void;
  onClickSplitVertically: () => void;
  onClickSplitHorizontally: () => void;
  onClickDelete: () => void;
  disableSplit?: boolean;
  mode: "create" | "edit";
}

export const SplitContentMenu: React.FC<Props> = ({
  onClickAttachContent,
  // onClickAttachContentGroup,
  onClickAttachHtml,
  onClickAttachUrl,
  onClickAttachDynamicTemplate,
  onClickSplitVertically,
  onClickSplitHorizontally,
  onClickDelete,
  disableSplit,
  mode,
}) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  const getButtonStyle = () => {
    if (isMobile) {
      return { width: "100px", height: "100px" };
    }
    return {};
  };

  return (
    <DropdownMenu>
      <DropdownMenuTrigger className="absolute top-2 right-2">
        <Button variant="secondary" className="" style={getButtonStyle()}>
          <CogIcon size={16} className="" style={{ transform: isMobile ? "scale(3)" : "scale(1)" }} />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent>
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <PaperclipIcon />
            {mode === "create" ? t("splitContent.attachContent") : t("splitContent.updateContent")}
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuItem onClick={onClickAttachContent}>
                <ImageIcon />
                <span>{t("splitContent.content")}</span>
              </DropdownMenuItem>
              {/* Temporarily disabled. Makes DSPlayer too complex */}
              {/* <DropdownMenuItem onClick={onClickAttachContentGroup}>
                <ImagesIcon />
                <span>{t("splitContent.contentGroup")}</span>
              </DropdownMenuItem> */}
              <DropdownMenuItem onClick={onClickAttachUrl}>
                <CodeIcon />
                <span>{t("splitContent.url")}</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onClickAttachHtml}>
                <CodeIcon />
                <span>{t("splitContent.html")}</span>
              </DropdownMenuItem>
              <DropdownMenuItem onClick={onClickAttachDynamicTemplate}>
                <ImagesIcon />
                <span>{t("splitContent.dynamicTemplate")}</span>
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
        <DropdownMenuSeparator />
        <DropdownMenuSub>
          <DropdownMenuSubTrigger>
            <SplitIcon />
            <span>{t("splitContent.split")}</span>
          </DropdownMenuSubTrigger>
          <DropdownMenuPortal>
            <DropdownMenuSubContent>
              <DropdownMenuItem
                disabled={disableSplit}
                onClick={() => {
                  onClickSplitVertically();
                }}
              >
                <FlipHorizontalIcon />
                <span>{t("splitContent.splitVertically")}</span>
              </DropdownMenuItem>
              <DropdownMenuItem
                disabled={disableSplit}
                onClick={() => {
                  onClickSplitHorizontally();
                }}
              >
                <FlipVerticalIcon />
                <span>{t("splitContent.splitHorizontally")}</span>
              </DropdownMenuItem>
            </DropdownMenuSubContent>
          </DropdownMenuPortal>
        </DropdownMenuSub>
        <DropdownMenuSeparator />
        <DropdownMenuItem onClick={onClickDelete}>{t("splitContent.deletePanel")}</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
